import React from 'react'
import { useTranslation } from 'i18n'
import Button from '@mui/material/Button'
import ButtonGroup from '@mui/material/ButtonGroup'
import { ChevronDown, ExternalLink } from 'lucide-react'

import Grow from '@mui/material/Grow'
import Paper from '@mui/material/Paper'
import Popper from '@mui/material/Popper'
import MenuItem from '@mui/material/MenuItem'
import MenuList from '@mui/material/MenuList'
import Link from '@mui/material/Link'

import './dropdown-button.scss'
import { ClickAwayListener } from '@mui/material'

export const DropdownButton = ({
  text,
  items = [],
  order,
  onClick = (id, text, url) => {},
  className,
}) => {
  const { t } = useTranslation('tipsAndTricks')
  const [open, setOpen] = React.useState(false)
  const anchorRef = React.useRef(null)

  const handleClick = (id, text, url) => {
    setOpen(false)
    onClick && onClick(id, text, url)
  }

  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen)
  }

  const handleClose = event => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return
    }

    setOpen(false)
  }

  // note: this format of using "link" comes from the data for Listicle MENU items
  items = items.filter(item => {
    return item.id && item.link && item.label
  })

  return (
    <div style={{ order: order, marginTop: '-15px' }}>
      <ButtonGroup
        variant="contained"
        color="primary"
        ref={anchorRef}
        aria-label={t('dropdown.groupAriaLabel')}
        style={{ boxShadow: 'none', marginTop: '15px' }}
      >
        <Button
          color="primary"
          size="small"
          className={className}
          aria-controls={open ? 'split-button-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-label={t('dropdown.toggleAriaLabel')}
          aria-haspopup="menu"
          onClick={handleToggle}
        >
          {text}
        </Button>
      </ButtonGroup>
      <Popper
        className="popper"
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu" className={`themed-menu`}>
                  {items.map((item, index) => (
                    <MenuItem
                      key={index}
                      // onClick={(event) => handleClick }
                      onClick={event => {
                        // need to use this syntax to hoist up handleClick()
                        handleClick(item.id, item.label, item.link)
                      }}
                      component={Link}
                      href={item.link}
                      target="_blank"
                      className={`themed-menu-link`}
                    >
                      {item.label}
                      <ExternalLink />
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </div>
  )
}
